/* Появление блоков при прокрутке.
   Написано здесь, а не взято с сайта: в сайтовом reveal.js вместе
   с появлением живёт моторика ЕГО первого экрана, которой тут нет.
   Правила соблюдены те же, они выстраданы на сайте:

   1. Класс СНИМАЕТСЯ при полном уходе из кадра и ставится заново при
      возврате — иначе вторая прокрутка идёт по уже собранной, мёртвой
      странице.
   2. Сбрасывать надо не по !isIntersecting, а по ПОЛНОМУ уходу: у
      наблюдателя есть порог, и элемент считается невидимым, ещё стоя
      краем в кадре — сброс по флагу гасил бы его прямо на глазах.
   3. Страховка через 2.5 с показывает всё, что оказалось выше сгиба,
      и НЕ снимает наблюдение: unobserve убил бы повтор навсегда. */

const ХОД = 30; /* меньше читается как мигание прозрачностью, а не как движение */

export function mountReveal(root: ParentNode = document): () => void {
  const узлы = Array.from(root.querySelectorAll<HTMLElement>("[data-reveal]"));
  if (!узлы.length) return () => {};

  const тихо = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (тихо) {
    /* Фолбэк показывает СТАТИЧНЫЙ КАДР, а не пустоту. */
    узлы.forEach((n) => n.classList.add("is-in"));
    return () => {};
  }

  document.documentElement.style.setProperty("--bz-reveal-dy", ХОД + "px");

  const ob = new IntersectionObserver(
    (записи) => {
      for (const з of записи) {
        const el = з.target as HTMLElement;
        if (з.isIntersecting) {
          const d = el.dataset.revealDelay;
          el.style.transitionDelay = d ? d + "ms" : "";
          el.classList.add("is-in");
        } else {
          const r = з.boundingClientRect;
          if (r.bottom <= 0 || r.top >= window.innerHeight) el.classList.remove("is-in");
        }
      }
    },
    { threshold: [0, 0.08], rootMargin: "0px 0px -8% 0px" },
  );
  узлы.forEach((n) => ob.observe(n));

  const страховка = window.setTimeout(() => {
    узлы.forEach((n) => {
      if (!n.classList.contains("is-in") && n.getBoundingClientRect().top < window.innerHeight) {
        n.classList.add("is-in");
      }
    });
  }, 2500);

  return () => {
    window.clearTimeout(страховка);
    ob.disconnect();
  };
}
